// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const closeMachineStatusModal = () =>

    dispatch => {

        document.body.classList.remove('warranty-modal-is-open');

        dispatch({
            type: actions.CLOSE_TCSM_MACHINE_STATUS_MODAL
        });

    };

export const openMachineStatusModal = actionToTake =>

    dispatch => {

        document.body.classList.add('warranty-modal-is-open');

        dispatch({
            actionToTake,
            type: actions.OPEN_TCSM_MACHINE_STATUS_MODAL
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/machine-status-modal.js